import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center pdb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Employers", -1)
const _hoisted_4 = {
  key: 0,
  class: "form-group row mb-4"
}
const _hoisted_5 = { class: "col-md-2 d-flex gap-2 justify-content-between align-items-center" }
const _hoisted_6 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Pending Requests"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_8 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Rejected Requests"
}
const _hoisted_9 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_10 = { class: "filters d-flex gap-4 flex-column flex-md-row justify-content-between w-100" }
const _hoisted_11 = { class: "d-flex gap-20 col-md-8 col-sm-12 flex-column flex-md-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_EmployerRequests = _resolveComponent("EmployerRequests")!
  const _component_SearchEmployersList = _resolveComponent("SearchEmployersList")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      errors: $setup.errors,
      success: $setup.success
    }, null, 8, ["errors", "success"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        ($setup.selectedType?.key == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["plan-modal iatse-icon-noun-reset fs-xl", { 'icon-active': _ctx.processed === 0 }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterRequests(0)))
                  }, null, 2)
                ]),
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["plan-modal iatse-icon-reset fs-xl", { 'icon-active': _ctx.processed === 3 }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.filterRequests(3)))
                  }, null, 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.selectedType,
              "onUpdate:selectedOption": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedType) = $event)),
              options: $setup.types,
              "single-arrow": true,
              customClass: "fs-xs w-50 w-sm-100"
            }, null, 8, ["selectedOption", "options"]),
            _createVNode(_component_SelectComponent, {
              selectedOption: $setup.filters.TaxID,
              "onUpdate:selectedOption": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.TaxID) = $event)),
              options: $setup.taxOptions,
              "single-arrow": true,
              customClass: "fs-xs w-50 w-sm-100",
              defaultOption: { key: 0, value: 'Filter by EIN/Tax ID #' }
            }, null, 8, ["selectedOption", "options"])
          ]),
          _createVNode(_component_TextInput, {
            type: "text",
            name: "mixed",
            placeholder: "Search by Company Name",
            max: 50,
            modelValue: $setup.filters.CompanyName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.CompanyName) = $event)),
            customClass: "search"
          }, null, 8, ["modelValue"])
        ]),
        ($setup.loading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($setup.selectedType?.key == 0)
                ? (_openBlock(), _createBlock(_component_EmployerRequests, {
                    key: 0,
                    employers: $setup.pendingEmployers,
                    processed: $setup.filters.Processed,
                    onFilterRequests: $setup.filterRequests,
                    onSendPin: $setup.sendPin,
                    onRejectRequest: $setup.rejectRequest
                  }, null, 8, ["employers", "processed", "onFilterRequests", "onSendPin", "onRejectRequest"]))
                : (_openBlock(), _createBlock(_component_SearchEmployersList, {
                    key: 1,
                    employers: $setup.employers,
                    onResetPin: $setup.resetPin,
                    onActivate: $setup.activateAccount,
                    onDeactivate: $setup.deactivateAccount
                  }, null, 8, ["employers", "onResetPin", "onActivate", "onDeactivate"]))
            ], 64))
      ]),
      (!$setup.loading)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 0,
            paginator: $setup.paginator,
            onFetchData: $setup.fetchPaginationData
          }, null, 8, ["paginator", "onFetchData"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}